import { AuthLevel } from 'src/app/enums/auth/auth.enum';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';
import { User } from '../../login/user/user.bean';
import { MenuItem } from '../menu-item/menu-item.bean';

export class MenuConf 
{
    item    ?:  MenuItem
    opened   :  boolean

    static isKind ( conf: any ) {
        return      conf        != undefined
                &&  conf.opened != undefined
    }

    static getMenuItem( operator: User, items: MenuItem[] )
    {
        if(!operator || !items) return null

        switch( operator.level ){
            case AuthLevel.CALLCENTER_OPERATOR:                
                return items.find( item => item.id == RoutingPages.MANAGEMENT_BOOKING)
            default:                
                return items.find( item => item.id == RoutingPages.DASHBOARD)
        }
    }
}